import { OrmMetadata } from "@natiwi/core/models/metadata";
import { NatCatalogController } from "@natiwi/core/controllers/catalog.controller";
import { NatMetadataRepository } from "@natiwi/core/network/repositories/metadata.repository";

export abstract class NatMetadataController<Model extends OrmMetadata> extends NatCatalogController<Model>{

    constructor(_repository: NatMetadataRepository<Model>) {
        super(_repository);
    }
}